import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    initialState
} from 'app/core/models/slice/tgr/tgrMain'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'tgrMain',
    initialState,
    reducers: {
        cleartgrMain: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        settgrMainObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        // action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const { cleartgrMain, settgrMainObArr } =
    slice.actions

export default slice.reducer
